/** @param {(key: string) => string} tk */
export function getPartnerFields(tk) {
  return [
    {
      name: "name_ar",
      label: tk("fields.nameAr"),
      type: "text",
      required: true,
    },
    {
      name: "name_en",
      label: tk("fields.nameEn"),
      type: "text",
      required: true,
    },
    {
      name: "logo",
      label: tk("fields.logo"),
      type: "file",
      maxFileMB: 2,
      hint: tk("hints.logo"),
    },
  ];
}
